import { connect } from "react-redux"

import {
    communitySelectAddMember,
    communitySelectRemoveParticipant,
    communityPromoteMember
} from "../../../../../actions/community-actions"

import {
    communityMembersListRequest,
    communityManagersListRequest,
    communityFollowersListRequest,
    communityInvitedListRequest,
    communityAwaitingApprovalListRequest
} from "../../../../../actions/community-participant-actions"

import InfiniteScroll from "../../../../common/InfiniteScroll"
import CommunityEditParticipantListItem from "./CommunityEditParticipantListItem"
import CommunityMemberAddListItem from "./CommunityMemberAddListItem"
import CommunityViewInvitedListItem from "../../view/participants/CommunityViewInvitedListItem"

const mapStateToProps = (
    { paging, presentation: { communities }, entities },
    { type, communityId, isAdding }
) => {
    const pagingList = isAdding
        ? paging.users
        : paging.communityParticipants[type]
    const searchCriteriaAccessor = isAdding
        ? "membersAdd"
        : communities.selectedParticipantType
    const searchCriteria =
        communities[`${searchCriteriaAccessor}SearchCriteria`]
    const pagingRequest = pagingList[searchCriteria] || {}
    let data = (pagingRequest.data || []).map(id => entities.users[id])
    if (isAdding) {
        data = data.map(member => {
            const isAdded = communities.membersSelectedToAdd
                .concat(communities.membersToAdd)
                .some(({ id }) => member.id === id)
            const isBeingRemoved = communities.membersSelectedToRemove.some(
                id => member.id === id
            )
            if (isAdded) return { ...member, isAdded: !isBeingRemoved }
            return member
        })
    } else {
        data = (
            communities[`${communities.selectedParticipantType}ToAdd`] || []
        ).concat(data)
        const selectedToRemove =
            communities[`${communities.selectedParticipantType}ToRemove`]
        data = data
            .filter(
                ({ id }) =>
                    !selectedToRemove || selectedToRemove.indexOf(id) === -1
            )
            .map(participant => {
                let is_manager = (participant.is_manager || {})[communityId]
                const is_member = (participant.is_member || {})[communityId]
                const isPromoted = participant[`isPromoted_${communityId}`]
                is_manager = is_manager || isPromoted
                const canBePromoted = !is_manager && is_member
                return {
                    ...participant,
                    is_manager,
                    canBePromoted
                }
            })
    }
    let itemComponent
    if (isAdding) {
        itemComponent = CommunityMemberAddListItem
    } else if (communities.selectedParticipantType === "invited") {
        itemComponent = CommunityViewInvitedListItem
    } else {
        itemComponent = CommunityEditParticipantListItem
    }
    return {
        itemComponent,
        data,
        itemStateProps: {
            type,
            communityId
        },
        isFetching: pagingRequest.isFetching,
        pagingRequest,
        communityId,
        containerClassName: "widget-content list-group auto"
    }
}

const mapDispatchToProps = (dispatch, { type, communityId }) => ({
    requestMoreData: pagingRequest => {
        switch (type) {
            case "managers":
                return dispatch(communityManagersListRequest(pagingRequest))
            case "followers":
                return dispatch(communityFollowersListRequest(pagingRequest))
            case "invited":
                return dispatch(communityInvitedListRequest(pagingRequest))
            case "awaiting_approval":
                return dispatch(
                    communityAwaitingApprovalListRequest(pagingRequest)
                )
            case "members":
            default:
                return dispatch(communityMembersListRequest(pagingRequest))
        }
    },
    itemActionProps: {
        addMember: member => () =>
            dispatch(communitySelectAddMember(member, !member.isAdded)),
        removeParticipant: (member, type) => () =>
            dispatch(communitySelectRemoveParticipant(member, type)),
        promoteMember: member => () =>
            dispatch(communityPromoteMember(member, communityId))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(InfiniteScroll)
